/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './MessageCenterContainer.scss';
import { toUpper } from 'lodash';
import { bool, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import PageLoadingContainer from 'components/layouts/Navigation/PageLoadingContainer';

import { getLocationRequestStateKey } from 'state/requests/RequestStatusSelectors';
import { requestStateConfig } from 'components/layouts/Navigation/RequestStateConfig';
import MessageCenter from '@trp-aam-accountaccess/message-component';
import { messageServiceBasePath } from 'services/Externals';
import {
  getApiKey,
  hasComposeQueryParam
} from 'state/session/SessionSelectors';
import PreferencesHeader from 'components/layouts/Preferences/PreferencesHeader';
import { getCustomerServiceType } from 'state/customer/CustomerSelectors';
import { getOwnedActiveProductTypes } from 'state/account/AccountSelectors';
import { hasTracOnly, getThemeShortName } from 'state/view/ViewSelectors';
import { getMessageNotifications } from 'services/Rest';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';

class MessageCenterContainer extends React.Component {
  componentWillUnmount() {
    getMessageNotifications();
  }

  render() {
    const {
      containerClass,
      hasError,
      productTypeIds,
      requestStatesKey,
      serviceType,
      showCompose,
      themeShortName,
      tracOnly,
      webViewEnabled
    } = this.props;

    const ENV = toUpper(window.config.environment) || 'PROD';
    return (
      <div className="message-center-container">
        <PreferencesHeader>
          <div className="message-center-header">Message Center</div>
        </PreferencesHeader>
        <PageLoadingContainer
          hasError={hasError}
          name="Message Center"
          requestStates={requestStateConfig[requestStatesKey]}
        />
        <div className={containerClass}>
          <MessageCenter
            apiKey={window.config.apiKey}
            baseUrl={messageServiceBasePath()}
            customerType={serviceType}
            accountTypes={productTypeIds}
            env={ENV}
            hasTracOnly={tracOnly}
            showCompose={showCompose}
            showInboxHeading={false}
            theme={themeShortName}
            webViewEnabled={webViewEnabled}
          />
        </div>
      </div>
    );
  }
}

MessageCenterContainer.propTypes = {
  apiKey: string.isRequired,
  hasError: bool.isRequired,
  requestStatesKey: string.isRequired,
  tracOnly: bool.isRequired
};

const mapStateToProps = (state) => ({
  apiKey: getApiKey(state),
  tracOnly: hasTracOnly(state),
  productTypeIds: getOwnedActiveProductTypes(state),
  requestStatesKey: getLocationRequestStateKey(state),
  serviceType: getCustomerServiceType(state),
  showCompose: hasComposeQueryParam(state),
  themeShortName: getThemeShortName(state),
  webViewEnabled: getCustomerWebView(state)
});

export default connect(mapStateToProps)(MessageCenterContainer);
